import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Alert,
  DatePicker, notification,
  Select,
} from 'antd';
import { INFINITE_EXPIRY_DATE } from '@Apis/constants';
import BatchActions from '@Actions/batchActions';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import H3FormInput from '@Uilib/h3FormInput';
import H3Text from '@Uilib/h3Text';
import dayjs from 'dayjs';
import './style.scss';
import InventoryLocationActions from '@Actions/settings/inventoryLocationActions';
import PRZSelect from '../../UI/PRZSelect';

const { Option } = Select;
/**
 * OfferForm component
 *
 * @param file
 */
class BatchForm extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      isBatchReady: false,
      selectedInventoryLocation: null,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (!state.isBatchReady) {
      const {
        expiryDays, nextBatchCode, prefillCostPrice, prefillLotNumber, prefillMrp, user, getInventoryLocations, destDepartmentId, locationId, locationPath,
      } = props;
      getInventoryLocations(destDepartmentId || user?.tenant_info?.default_store_id, '', null, true);

      return {
        ...state,
        batchNumber: nextBatchCode,
        lotNumber: prefillLotNumber,
        costPrice: prefillCostPrice,
        selectedInventoryLocation: locationId,
        selectedInventoryLocationName: locationPath,
        mrp: prefillMrp,
        expiryDate: expiryDays > 0 ? (dayjs().add(expiryDays || 0, 'day')) : dayjs(INFINITE_EXPIRY_DATE),
        isBatchReady: true,
      };
    }

    return state;
  }

  /**
   *
   */
  createBatch() {
    this.setState({ formSubmitted: true });
    const {
      uomId, costPrice, mrp, expiryDate, batchNumber, lotNumber, quantity, selectedInventoryLocation, selectedInventoryLocationName,
    } = this.state;
    const {
      createBatch, callback, user, expiryDays, tenantProductId, onSubmit, isTemporaryBatch, batchUom, destDepartmentId, locationId, locationPath,
    } = this.props;
    const isWarehouseLocationRequired = user?.tenant_info?.inventory_config?.settings?.is_inventory_location_mandatory;
    const enabledWarehouseLocations = user?.tenant_info?.inventory_config?.settings?.enable_location_based_stock;
    this.setState({ formSubmitted: true });
    const payload = {
      batch_id: null,
      tenant_product_id: tenantProductId,
      available_qty: quantity,
      expiry_date: expiryDays > 0 ? dayjs(expiryDate).format('YYYY-MM-DD') : INFINITE_EXPIRY_DATE,
      lot_number: lotNumber || '',
      custom_batch_number: batchNumber,
      cost_price: costPrice || 0,
      mrp: mrp || 0,
      selling_price: 0,
      tenant_department_id: destDepartmentId || user?.tenant_info?.default_store_id,
      uom_id: batchUom?.uom_id,
      manual_entry: true,
      inventory_location_id: selectedInventoryLocation || locationId,
      inventory_location_path: selectedInventoryLocationName || locationPath,
      is_rejected_batch: false,
    };
    if (!isTemporaryBatch) {
      if (quantity && uomId) {
        if (enabledWarehouseLocations && isWarehouseLocationRequired && !payload.inventory_location_id) {
          // missing location
        } else {
          createBatch({ ...payload, uom_id: uomId }, () => {
            callback();
            this.setState({
              formSubmitted: false,
              quantity: null,
              expiryDate: null,
              lotNumber: null,
              batchNumber: null,
              costPrice: null,
              mrp: null,
              uomId: null,
              selectedInventoryLocation: null,
            });
          });
        }
      }
    } else if (batchNumber) {
      if (enabledWarehouseLocations && isWarehouseLocationRequired && !payload.inventory_location_id) {
        // missing location
      } else {
        onSubmit(payload);
      }
    }
  }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      uomId, costPrice, mrp, expiryDate, formSubmitted, batchNumber, lotNumber, quantity, selectedInventoryLocation,
    } = this.state;
    const {
      createBatchLoading, uomList, expiryDays, isTemporaryBatch, user, getInventoryLocationsLoading, destDepartmentId, getInventoryLocations, inventoryLocations, MONEY_SYMBOL,
    } = this.props;
    const enabledWarehouseLocations = user?.tenant_info?.inventory_config?.settings?.enable_location_based_stock;
    const isWarehouseLocationRequired = user?.tenant_info?.inventory_config?.settings?.is_inventory_location_mandatory;
    const isBatchNumberEditable = user?.tenant_info?.inventory_config?.settings?.batch_management?.is_batch_number_editable;
    return (

      <div style={{ paddingBottom: '90px' }}>
        <div className="ant-row">
          {!isTemporaryBatch && (
            <div className="ant-col-md-16">
              <H3FormInput
                name="Quantity"
                type="number"
                containerClassName="orgInputContainer"
                labelClassName="orgFormLabel"
                inputClassName="orgFormInput"
                placeholder=""
                onChange={(event) => this.setState({ quantity: event.target.value })}
                value={quantity}
                label="Quantity"
                required
                disabled={createBatchLoading}
                showError={formSubmitted && !quantity}
              />
            </div>
          )}
          {!isTemporaryBatch && (
            <div className="ant-col-md-8">
              <div className="orgInputContainer" style={{ marginLeft: '5%', width: '95%', marginTop: '2px' }}>
                <H3Text text="Unit" required className="orgFormLabel" />
                <PRZSelect
                  dropdownAlign={{ offset: [-6, 4] }}
                  filterOption={false}
                  className=""
                  value={uomId}
                  onChange={(value) => {
                    this.setState({
                      uomId: value,
                      uomInfo: uomList?.find((rec) => rec?.uom_id === value),
                    });
                  }}
                >
                  {
                    uomList?.map((uom) => (
                      <Option
                        key={uom?.uom_id}
                        value={uom?.uom_id}
                      >
                        {`${uom?.uqc?.toProperCase()} (${uom?.uom_name?.toProperCase()})`}
                      </Option>
                    ))
                  }
                </PRZSelect>
              </div>
            </div>
          )}
          {expiryDays > 0 && (
            <div className="ant-col-md-24" style={{ marginBottom: '10px' }}>
              <H3Text text="Expiry Date" required className="orgFormLabel" />
              <DatePicker
                value={expiryDate}
                onChange={(value) => {
                  this.setState({ expiryDate: value });
                }}
                disabled={createBatchLoading}
                style={{
                  height: '32px',
                  width: '100%',
                  marginBottom: '15px',
                }}
              />
              {' '}
              {formSubmitted && !expiryDate && <div className="input-error">*Please enter date</div>}
              <Alert
                message={`This product has default shelf life of ${expiryDays} days.`}
                type="info"
                showIcon
                className="add-product-batch-info-message"
              />
            </div>
          )}
          <div className="ant-col-md-24">
            <H3FormInput
              name="Batch Number"
              type="text"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState({ batchNumber: event.target.value })}
              value={batchNumber}
              label="Batch Number"
              required={isTemporaryBatch}
              disabled={createBatchLoading || !isBatchNumberEditable}
              showError={isTemporaryBatch && formSubmitted && !batchNumber}
            />
          </div>
          <div className="ant-col-md-24">
            <H3FormInput
              name="Lot Number"
              type="text"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => this.setState({ lotNumber: event.target.value })}
              value={lotNumber}
              label="Lot Number"
              disabled={createBatchLoading}
            />
          </div>
          <div className="ant-col-md-24">
            <H3FormInput
              name=" vendor price"
              type="number"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => (event.target.value > -1 ? this.setState({ costPrice: event.target.value }) : this.setState({ offerPrice: '' }))}
              value={costPrice}
              label={`Batch Cost Price (${MONEY_SYMBOL})`}
              disabled={createBatchLoading}
            />
          </div>
          <div className="ant-col-md-24">
            <H3FormInput
              name=" MRP"
              type="number"
              containerClassName="orgInputContainer"
              labelClassName="orgFormLabel"
              inputClassName="orgFormInput"
              placeholder=""
              onChange={(event) => (event.target.value > -1 ? this.setState({ mrp: event.target.value }) : this.setState({ offerPrice: '' }))}
              value={mrp}
              label={`MRP (${MONEY_SYMBOL})`}
              disabled={createBatchLoading}
            />
          </div>
          {enabledWarehouseLocations && (
            <div className="ant-col-md-24">
              <div className="orgInputContainer" style={{ width: '100%', marginTop: '2px' }}>
                <H3Text text="Select Put Away Location" required className="orgFormLabel" />
                <PRZSelect
                  value={selectedInventoryLocation}
                  loading={getInventoryLocationsLoading}
                  filterOption={false}
                  showSearch
                  onChange={(value) => {
                    this.setState({
                      selectedInventoryLocation: value,
                      selectedInventoryLocationName: inventoryLocations?.inventory_location?.find((item) => item.inventory_location_id == value)?.inventory_location_path,
                    });
                  }}
                  onSearch={(keyword) => {
                    getInventoryLocations(destDepartmentId || user?.tenant_info?.default_store_id, keyword, null, true);
                  }}
                >
                  {
                    inventoryLocations?.inventory_location?.filter((item) => item?.is_active)?.map((item) => (
                      <Option
                        key={item?.inventory_location_id}
                        value={item?.inventory_location_id}
                      >
                        <H3Text text={item?.inventory_location_path} className="create-new-batch__location-item" />
                      </Option>
                    ))
                  }
                </PRZSelect>
                {isWarehouseLocationRequired && formSubmitted && !selectedInventoryLocation && <H3Text text="Please select the location in your warehouse" className="input-error" />}
              </div>
            </div>
          )}
          <div className="ant-col-md-24">
            <div className="create-new-batch__footer">
              <H3Button
                buttonType={defaultButtonTypes.BLUE_ROUNDED}
                text="Add Batch"
                onClick={() => this.createBatch()}
                disabled={createBatchLoading}
                isLoading={createBatchLoading}
                style={{
                  width: '200px',
                  borderRadius: '5px',
                  padding: '7px 0px',
                  marginLeft: '0',
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ UserReducers, BatchReducers, InventoryLocationReducers }) => ({
  createBatchLoading: BatchReducers.createBatchLoading,
  inventoryLocations: InventoryLocationReducers.inventoryLocations,
  getInventoryLocationsLoading: InventoryLocationReducers.getInventoryLocationsLoading,
  user: UserReducers.user,
  MONEY_SYMBOL: UserReducers.MONEY_SYMBOL,
});

const mapDispatchToProps = (dispatch) => ({
  createBatch: (payload, callback) => dispatch(BatchActions.createBatch(payload, callback)),
  getInventoryLocations: (tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable) => dispatch(InventoryLocationActions.getInventoryLocations(tenantDepartmentId, inventoryLocationPath, parentLocationId, isStorable)),
});

BatchForm.propTypes = {
  createBatchLoading: PropTypes.bool,
  createBatch: PropTypes.func,
  user: PropTypes.any,
  callback: PropTypes.func,
  expiryDays: PropTypes.any,
  tenantProductId: PropTypes.any,
  onSubmit: PropTypes.func,
  nextBatchCode: PropTypes.string,
  uomList: PropTypes.any,
  batchUom: PropTypes.any,
  destDepartmentId: PropTypes.any,
  prefillCostPrice: PropTypes.any,
  prefillMrp: PropTypes.any,
  isTemporaryBatch: PropTypes.bool,
  getInventoryLocations: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BatchForm));
